import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { IMetaTag } from '.';

export type TAdminGetMetaTags = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminCreateMetaTag = {
  path: string;
  title: string;
  description: string;
};

export type TAdminUpdateMetaTag = {
  _id: string;
  path: string;
  title: string;
  description: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetMetaTagsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetMetaTags) => {
  let path = `${AdminApiPaths.metaTags}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IMetaTag>>
  >(path);

  return response.data;
};

export const adminCreateMetaTag = createAsyncThunk(
  '/admin/meta-tags/create',
  async (data: TAdminCreateMetaTag) => {
    const path = `${AdminApiPaths.metaTags}`;

    const response = await apiDataProvider.post<TApiResponse<IMetaTag>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateMetaTag = createAsyncThunk(
  '/admin/meta-tags/update',
  async (data: TAdminUpdateMetaTag) => {
    const path = `${AdminApiPaths.metaTags}/${data._id}`;

    const response = await apiDataProvider.put<TApiResponse<IMetaTag>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteMetaTag = createAsyncThunk(
  '/admin/meta-tags/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.metaTags}/${id}`;

    const response = await apiDataProvider.delete<TApiResponse<IMetaTag>>(path);

    return response.data;
  }
);

export const adminGetMetaTags = createAsyncThunk(
  '/admin/meta-tags/list',
  adminGetMetaTagsModule
);
